import {importRoutes} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function Imports() {
  const navigate = useNavigate();

  const handleActionCallback: ActionCallback = (action) => {
    const id = Array.isArray(action.rowId) ? action.rowId[0] : action.rowId;

    navigate(composePath(importRoutes.detail, {params: {id}}));
  };

  return <DmsDataGrid gridCode="import" actionCallback={handleActionCallback} />;
}
